import { SVG } from '../SVG'

export const YoutubeIcon = ({ style = {}, ...props }) => (
  <SVG
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...style }}
    {...props}
  >
    <path
      d='M16.877 0.250001C7.5822 0.246998 -0.00900053 7.84032 8.00961e-06 17.1315C0.00901655 26.4317 7.60822 34.021 16.891 34C26.2009 33.979 33.786 26.3746 33.75 17.0985C33.713 7.79027 26.1648 0.253004 16.877 0.250001ZM26.2769 20.3701C26.2649 22.127 24.7415 23.6667 22.9898 23.6727C18.9119 23.6867 14.8331 23.6867 10.7552 23.6727C9.02256 23.6667 7.48711 22.131 7.47409 20.4031C7.45708 18.2137 7.45708 16.0243 7.47409 13.8349C7.48711 12.135 8.98953 10.6013 10.6841 10.5783C12.7481 10.5503 14.8121 10.5713 16.876 10.5713C18.928 10.5713 20.9799 10.5503 23.0308 10.5773C24.7725 10.6003 26.2659 12.131 26.2769 13.8769C26.2909 16.0413 26.2909 18.2057 26.2769 20.3701Z'
      fill='#E53935'
    />
    <path
      d='M23.0304 10.5782C20.9795 10.5512 18.9276 10.5722 16.8756 10.5722C14.8117 10.5722 12.7467 10.5512 10.6837 10.5792C8.98914 10.6023 7.48671 12.136 7.4737 13.8358C7.45668 16.0252 7.45668 18.2146 7.4737 20.404C7.48671 22.1319 9.02217 23.6676 10.7548 23.6736C14.8327 23.6876 18.9115 23.6876 22.9894 23.6736C24.7411 23.6676 26.2645 22.1289 26.2765 20.371C26.2905 18.2066 26.2905 16.0422 26.2765 13.8779C26.2655 12.132 24.7721 10.6013 23.0304 10.5782ZM14.5254 20.7184V13.6246C16.4552 14.8179 18.335 15.9802 20.2618 17.1705C18.338 18.3608 16.4622 19.5201 14.5254 20.7184Z'
      fill='white'
    />
    <path
      d='M16.8764 10.5707C18.9284 10.5707 20.9803 10.5487 23.0313 10.5767C20.9803 10.5497 18.9284 10.5707 16.8764 10.5707C14.8125 10.5707 12.7475 10.5497 10.6846 10.5777C12.7485 10.5497 14.8125 10.5707 16.8764 10.5707Z'
      fill='white'
    />
    <path
      d='M14.5254 20.7168C16.4622 19.5185 18.338 18.3592 20.2618 17.1689C18.335 15.9776 16.4552 14.8154 14.5254 13.623V20.7168Z'
      fill='#E53935'
    />
  </SVG>
)

export default YoutubeIcon
